import styled from 'styled-components';

export const PriceTrend = styled.div({
  borderTop: 'none',
  marginTop: '10px',
  paddingTop: '0px',
  marginBottom: '0px',
});
